var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBannerLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 592,
  height: 313,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FF",
  d: "M579.501-68.983c-63 74.5-367.292 358.312-579.5 376.5 308.499 54.5 661.999-333 579.5-376.5"
})));
export { SvgBannerLine as ReactComponent };
export default __webpack_public_path__ + "b55e0190d6d1679b0fa83088831b4697.svg";